import { useState } from 'react';
import { motion } from 'framer-motion';
import WaitlistModal from '../WaitlistModal';
import { useBreakpoint } from '../../hooks/useBreakpoint';

const FooterSection = () => {
  const { isMobile } = useBreakpoint();
  const [ctaHovered, setCtaHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const ctaStyle = {
    width: '100%',
    padding: '20px 0',
    textAlign: 'center',
    border: '1px solid #F2F2F2',
    background: ctaHovered ? '#00FF41' : 'transparent',
    color: ctaHovered ? '#050505' : '#F2F2F2',
    fontSize: 14,
    textTransform: 'uppercase',
    letterSpacing: '0.2em',
    cursor: 'none',
  };

  return (
    <section style={{ padding: isMobile ? '60px 20px' : '80px 16px' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <motion.div
          style={{ marginBottom: 48 }}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <h2
            style={{
              fontSize: 'clamp(24px, 6vw, 56px)',
              fontWeight: 600,
              letterSpacing: '-0.04em',
              lineHeight: 1.1,
              marginBottom: 16,
            }}
          >
            PRIVACY IS THE
            <br />
            ULTIMATE LUXURY.
          </h2>
          <h3
            style={{
              fontSize: 'clamp(24px, 6vw, 56px)',
              fontWeight: 600,
              letterSpacing: '-0.04em',
              color: 'rgba(242,242,242,0.3)',
            }}
          >
            GO BLANK.
          </h3>
        </motion.div>

        <motion.button
          data-hover
          className="font-mono"
          onClick={() => setIsModalOpen(true)}
          onMouseEnter={() => setCtaHovered(true)}
          onMouseLeave={() => setCtaHovered(false)}
          style={ctaStyle}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          [ DOWNLOAD APP ]
        </motion.button>

        <WaitlistModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

        <div
          style={{
            marginTop: 48,
            paddingTop: 24,
            borderTop: '1px solid rgba(242,242,242,0.1)',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: isMobile ? 20 : 16,
          }}
        >
          <p
            className="font-mono"
            style={{
              fontSize: isMobile ? 9 : 10,
              color: 'rgba(242,242,242,0.3)',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
            }}
          >
            © 2025 BLANK
          </p>
          <div style={{ display: 'flex', gap: isMobile ? 20 : 24 }}>
            {['DOCS', 'GITHUB', 'STATUS'].map((link) => (
              <a
                key={link}
                href="#"
                data-hover
                className="font-mono"
                style={{
                  fontSize: 10,
                  color: 'rgba(242,242,242,0.3)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  textDecoration: 'none',
                }}
                onMouseEnter={(e) => (e.target.style.color = '#00FF41')}
                onMouseLeave={(e) => (e.target.style.color = 'rgba(242,242,242,0.3)')}
              >
                {link}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterSection;
